// extracted by mini-css-extract-plugin
export default {"root":"InfoTooltip_root__8HFdr"};